// extracted by mini-css-extract-plugin
export default {"outstanding_wrapper":"outstanding_outstanding_wrapper__PnBfx","heading":"outstanding_heading__iroTp"};